var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { completedPage, submittedMfaSelection } from "../../../lib/Avo";
import { MFAInput } from "./MfaInput";
import { MFASelection } from "./MfaSelection";
import useAppSelector from "../../../hooks/useAppSelector";
import { useLocation } from "react-router-dom";
import { usePostMFAOptionMutation } from "../../../services/connect";
var MFA_PHASE;
(function (MFA_PHASE) {
    MFA_PHASE["selection"] = "SELECTION";
    MFA_PHASE["input"] = "INPUT";
})(MFA_PHASE || (MFA_PHASE = {}));
function MFAReducer(prevState, nextState) {
    return __assign(__assign({}, prevState), nextState);
}
export function MFA(_a) {
    var connectionId = _a.connectionId, selectedIssuer = _a.selectedIssuer, challengeData = _a.challengeData;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var _b = React.useReducer(MFAReducer, {
        mfaPhase: MFA_PHASE.selection,
        failed: false,
        inProgress: false,
    }), _c = _b[0], mfaPhase = _c.mfaPhase, failed = _c.failed, inProgress = _c.inProgress, setState = _b[1];
    var location = useLocation();
    var postMFAOption = usePostMFAOptionMutation({
        fixedCacheKey: location.pathname,
    })[0];
    function handleOptionSelected(selectedOption) {
        if (selectedOption === null) {
            return;
        }
        setState({ mfaPhase: MFA_PHASE.input });
        submittedMfaSelection(commonAnalyticsProperties);
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: "".concat(selectedOption), optionSelected: "".concat(selectedOption) }));
        postMFAOption({ id: connectionId, mfaOption: selectedOption });
    }
    if (mfaPhase === MFA_PHASE.selection) {
        return (React.createElement(MFASelection, { handleOptionSelected: handleOptionSelected, selectedIssuer: selectedIssuer, challengeData: challengeData }));
    }
    if (mfaPhase === MFA_PHASE.input) {
        return (React.createElement(MFAInput, { failed: failed, inProgress: inProgress, selectedIssuer: selectedIssuer, setMFAState: setState, connectionId: connectionId }));
    }
    return null;
}
